/**
 * The Production Records calendar rail — the Orders month calendar
 * (`WeekMonthCalendar`) in DAY mode with the Orders colour language: green
 * for a day whose record is complete, red for a past day whose record is
 * not, muted for every day without a record (Sheila: calendar-driven like
 * Orders; keep the two as one shared UI pattern). Clicking a day asks the
 * page to jump the timeline there.
 */

import { WeekMonthCalendar } from '@/components/orders/school/week-month-calendar'
import { todayKey } from '@/lib/school-orders/calendar'

export interface ProductionCalendarProps {
  /** The day the user last clicked; none until they do. */
  selectedDayKey: string | null
  /** yyyy-mm-dd keys whose record is complete (green). */
  completeDates: ReadonlySet<string>
  /** yyyy-mm-dd past keys whose record is incomplete (red). */
  attentionDates: ReadonlySet<string>
  onSelectDay: (dayKey: string) => void
  /** Injected by tests; the local calendar day otherwise. */
  today?: string
}

export function ProductionCalendar({
  selectedDayKey,
  completeDates,
  attentionDates,
  onSelectDay,
  today = todayKey(),
}: ProductionCalendarProps) {
  return (
    <WeekMonthCalendar
      anchorKey={selectedDayKey ?? today}
      selectedWeekKeys={[]}
      selectedDayKey={selectedDayKey ?? undefined}
      orderedDates={completeDates}
      attentionDates={attentionDates}
      // Every day without a record renders muted. The calendar paints a day
      // black only while it is "orderable" (`isDayOrderable`: in the future
      // AND its week's window still open); closing every week makes the
      // future days — which cannot have a record yet — as muted as the past
      // ones, and the complete / incomplete colours paint over that.
      isWeekClosed={() => true}
      onSelectDay={onSelectDay}
      orderedLegendLabel="Complete"
      attentionLegendLabel="Incomplete"
    />
  )
}
